import './app/index.css';
import { estRouteSupervision } from './supervision/route';

// Choix avant import du métier : aucune base ni sync derrière la consultation.
const supervision = estRouteSupervision(globalThis.location.hash);
window.addEventListener('hashchange', () => {
  if (estRouteSupervision(globalThis.location.hash) !== supervision) window.location.reload();
});
if (supervision) {
  // Le raccourci du téléphone rouvre la consultation, pas le poste par défaut.
  const manifeste = document.querySelector<HTMLLinkElement>('link[rel="manifest"]') ?? document.createElement('link');
  manifeste.rel = 'manifest';
  manifeste.href = '/supervision.webmanifest';
  if (!manifeste.parentNode) document.head.appendChild(manifeste);
  void import('./supervision/bootstrap').then(({ demarrerSupervision }) => demarrerSupervision());
} else {
  void import('./bootstrap-service').then(({ demarrerService }) => demarrerService());
}
